// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Flex } from '../../grid';
import { applyRangeFilter, getRangeFilter, getMinMaxFromFacet } from '../../../store/assortment';
import { RangeSlider } from '../../form';
import RangeInput from './rangeInput';

type DispatchProps = {|
  filter: (label: string, from: number, to: number) => *,
|};

type StateProps = {|
  min: number,
  max: number,
  selectedFrom: number,
  selectedTo: number,
|};

type OwnProps = {|
  name: string,
|};

type Props = {|
  ...DispatchProps,
  ...OwnProps,
  ...StateProps,
|};

/* eslint-disable  jsx-a11y/label-has-for */

class RangeSliderFacet extends Component<Props> {
  values: { from: number, to: number };

  shouldComponentUpdate(nextProps: Props) {
    const {
      min, max, selectedFrom, selectedTo,
    } = this.props;

    if (nextProps.min !== min || nextProps.max !== max) {
      return true;
    }

    if (nextProps.selectedTo !== selectedTo
      || nextProps.selectedFrom !== selectedFrom) {
      return true;
    }

    return false;
  }

  onFilter = (from: number, to: number) => {
    const { filter, name } = this.props;

    filter(name, from, to);
  }

  onSliderChange = () => {
    const { from, to } = this.values;
    if (!isNaN(from) && !isNaN(to)) { // eslint-disable-line no-restricted-globals
      this.onFilter(from, to);
    }
  }

  render() {
    const {
      selectedFrom, selectedTo, min, max,
    } = this.props;

    return (
      <Flex flexDirection="column" justifyContent="space-between" py="0.2rem">
        <Flex>
          <RangeSlider
            min={min}
            max={max}
            onValuesUpdated={({ values: [from, to] }) => {
              this.values = { from, to };
            }}
            onSliderDragEnd={this.onSliderChange}
            values={[selectedFrom, selectedTo]}
          />
        </Flex>
        <RangeInput
          from={selectedFrom}
          to={selectedTo}
          onValuesUpdated={(from, to) => {
            this.onFilter(from, to);
          }}
        />
      </Flex>
    );
  }
}

const mapStateToProps = (state: any, { name }: OwnProps): StateProps => {
  const { min, max } = getMinMaxFromFacet(state, name);
  const rangeFilter = getRangeFilter(state, name);

  const selectedFrom = rangeFilter ? rangeFilter.from : min;
  const selectedTo = rangeFilter ? rangeFilter.to : max;

  return {
    selectedFrom,
    selectedTo,
    min,
    max,
  };
};

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  filter: (label: string, from: number, to: number) => dispatch(applyRangeFilter(label, from, to)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(RangeSliderFacet);
